export const isNumeric = (checkValue: any): boolean => {
  const parsedValue = parseFloat(checkValue);
  return !Number.isNaN(parsedValue) && Number.isFinite(parsedValue);
};

// https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
export const appendOrdinal = (n: number): string => {
  if (typeof n !== 'number') return '';
  const a = n % 10;
  const b = n % 100;
  if (a === 1 && b !== 11) {
    return `${n}st`;
  }
  if (a === 2 && b !== 12) {
    return `${n}nd`;
  }
  if (a === 3 && b !== 13) {
    return `${n}rd`;
  }
  return `${n}th`;
};

export const getThousandsAbbreviation = (n: number): string => {
  if (!n || !isNumeric(n)) return '0';
  const thousands = n / 1000;
  return `${thousands.toFixed(1)}k`;
};

export const getNextPowerOf = (base, power) =>
  Math.pow(power, Math.ceil(Math.log(base) / Math.log(power)));
